export enum Routes {
  PROFILE = '/profile',
  BILLING = '/profile#billing',
  REFERRAL = '/referral',
  SIGNUP = '/signup',
  WELCOME = '/welcome'
}
